/**
 * @module components\ghDialog
 */
import Vue from "vue";
import { Component, Prop, Watch, Emit, Model } from "vue-property-decorator";
import GhModelView from "./../ghModelView/ghModelView";

@Component
export default class GhDialog extends Vue {
  [key: string]: any;

  private show: any = false;

  @Prop()
  private modelProps!: IProp[];

  @Prop({ default: false })
  private keep!: boolean;

  private model = {};

  private title: string = "新增";

  private validate() {
    let form = this.$refs.view as GhModelView;
    if (form.validate()) {
      this.$emit("submit");
      return true;
    }
    return false;
  }

  private cancelModel() {
    this.show = false;
    this.$emit("cancel");
  }

  private get BtnOk(): Vue {
    return this.$refs.btnOk as Vue;
  }

  private get BtnCancel(): Vue {
    return this.$refs.btnCancel as Vue;
  }

  public open(model: {}, title?: string): Promise<object> {
    // this.model = {};
    //
    let promise = new Promise<Object>((resolve, reject) => {
      this.show = true;
      if (this.title) {
        this.title = title as string;
      }
      let json = JSON.stringify(model);
      let copyModel = JSON.parse(json);
      this.model = copyModel;
      this.$on("submit", () => {
        resolve(this.model);
        if (!this.keep) {
          this.show = false;
        }
      });
      this.BtnCancel.$on("click", () => {
        if (reject) {
          reject(this.model);
        }
        this.show = false;
      });
    });
    return promise;
  }
}
